const IMAGE_MAX_LONG_EDGE = 2048;
const IMAGE_JPEG_QUALITY = 0.85;

const isHeicImage = (file) => {
  const type = String(file?.type || '').toLowerCase();
  const name = String(file?.name || '').toLowerCase();
  return type.includes('heic') || type.includes('heif')
    || name.endsWith('.heic') || name.endsWith('.heif');
};

const getOutputFormat = (file) => {
  const type = String(file?.type || '').toLowerCase();
  const name = String(file?.name || '').toLowerCase();
  const isPng = type === 'image/png' || name.endsWith('.png');

  return isPng
    ? { mimeType: 'image/png', extension: 'png' }
    : { mimeType: 'image/jpeg', extension: 'jpg' };
};

export const resizeImageForUpload = async (file) => {
  if (!file || isHeicImage(file)) {
    return file;
  }

  try {
    const { mimeType, extension } = getOutputFormat(file);
    const bitmap = await createImageBitmap(file);
    const longestEdge = Math.max(bitmap.width, bitmap.height);
    const scale = longestEdge > IMAGE_MAX_LONG_EDGE
      ? IMAGE_MAX_LONG_EDGE / longestEdge
      : 1;
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (!context) {
      bitmap.close?.();
      return file;
    }

    context.drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();

    const blob = await new Promise((resolve, reject) => {
      const callback = (result) => (
        result ? resolve(result) : reject(new Error('image-resize-failed'))
      );
      if (mimeType === 'image/jpeg') {
        canvas.toBlob(callback, mimeType, IMAGE_JPEG_QUALITY);
      } else {
        canvas.toBlob(callback, mimeType);
      }
    });

    const baseName = String(file.name || 'image').replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}.${extension}`, {
      type: mimeType,
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error('Failed to resize image for upload:', error);
    return file;
  }
};

export const resizeImagesForUpload = async (files) => (
  Promise.all((files || []).map((file) => resizeImageForUpload(file)))
);
